<div class="dialogLogoutMain">
  <p mat-dialog-title class="dialogLogoutTitle">{{ data.title }}</p>
  <div mat-dialog-content>
    <p class="dialogLogoutText">{{ data.text }}</p>
  </div>
  <div>
    @if (data.no) {
      <button
        mat-button
        [mat-dialog-close]="false"
        class="dialogLogoutBtnNo"
        >
        <mat-icon class="dialogIconNo">close</mat-icon>{{ data.no }}
      </button>
    }
    <button mat-button [mat-dialog-close]="true" class="dialogLogoutBtnYes">
      {{ data.yes }} <mat-icon class="dialogIconYes">check</mat-icon>
    </button>
  </div>
</div>
